// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const geminiApi = {
  fetchAuthorized: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/isAuthorized/${pcId}`, 'GET').execute(),
  fetchShoppingCenter: (pcId: string, year: ?string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}`, 'GET')
    .addParam('year', year)
    .execute(),
  fetchShoppingCenterDwellPercent: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/footfall`, 'GET').execute(),
  fetchShoppingCenterFootfalls: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/footfall-doors`, 'GET').execute(),
  fetchStoresHistory: (pcId: string, codstr: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/stores/${codstr}/history`, 'GET')
    .execute(),
  fetchStoreProxyStoresSale: (codstr: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/stores/${codstr}/proxy`, 'GET')
    .execute(),
  fetchVisioglobeUnits: (pcId: string, year: number) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/visioglobe-units`, 'GET')
    .addParam('year', year)
    .execute(),
  fetchStoresComparable: (codstr: number, retailerId: number, pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/retailers/${retailerId}/stores/${codstr}/comparables`, 'GET').execute(),
  fetchBranchLevels: (pcId: string, year: string, levelAggregation: string) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/branch-levels`, 'GET')
    .addParam('year', year)
    .addParam('levelAggregation', levelAggregation)
    .execute(),
  fetchM5Report: (pcId: string, year: number, month: number) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/reports/m5`, 'GET')
    .addParam('year', year)
    .addParam('month', month)
    .execute(),
  fetchM2Report: (pcId: string, retailerId: number, year: number, month: number) => new RestClientAuthenticated(`${turanBaseURL()}/gemini/shopping-centers/${pcId}/retailers/${retailerId}/reports/m2`, 'GET')
    .addParam('year', year)
    .addParam('month', month)
    .execute(),
  fetchReconciliation: (pcId: string) => new RestClientAuthenticated(`/api/gemini/shopping-centers/${pcId}/reconciliation`, 'GET').execute(),
  saveStoreDistances: (pcId: number, storeDistances: any) =>
    new RestClientAuthenticated(`/api/gemini/shopping-centers/${pcId}/stores/distances`, 'POST')
      .jsonBody(storeDistances)
      .execute(),
};

export default geminiApi;
